import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DocumentListing from "../../CommonComponents/DocumentListing";

const DocumentManagement = ({
  isLoading,
  deleteResult,
  deleteAdverseAction,
  jacket,
  ...props
}) => {
  const history = useNavigate();

  return (
    <DocumentListing
      title={"Jackets"}
      isDocumentManagement={true}
      isShowActions={true}
      isDashboard={false}
      jacket={jacket}
    />
  );
};

export default DocumentManagement;
